import { render, staticRenderFns } from "./TeacherEmail.vue?vue&type=template&id=4fe010d2&"
import script from "./TeacherEmail.vue?vue&type=script&lang=js&"
export * from "./TeacherEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports